const SourceGenerator = {
  generatePipeline(pipeline) {
    let source = `pipeline "${pipeline.title}"
`;
    pipeline.stages.forEach((stage) => {
      var _a;
      source += `stage ${stage.stage} match ${((_a = stage.match) == null ? void 0 : _a.toLowerCase()) || "either"}
`;
      stage.rules.forEach((rule) => {
        source += `rule "${rule}"
`;
      });
    });
    source += "end";
    return source;
  }
};
export default SourceGenerator;
